export enum Category {
    SoftIceCream = 'Mjukglass',
    GuteSnurr = 'Gutesnurr',
    Milkshake = 'Milkshake',
    GuteStruten = 'Gutestruten',
    IceCreamMenu = 'Glassmeny'
}

export enum GuteSnurr {
    CaramelButterscotch = 'Kolaknäck',
    Trippelchoklad = 'Trippelchoklad',
    Lemon = 'Lemoncurd & Maräng',
    Polka = 'Polka',
    HallonLakrits = 'Hallon & Lakrits',
    Nougat = 'Nougat',
    Customized = 'Customized'
}

export enum Milkshake {
    DagensMilkshake = 'Dagens Milkshake'
}

export enum GuteStruten {
    HonungSaffranHallon = 'Honung & Saffran & Hallon',
    SaltKolaPopcorn = 'Salt gräddkola & Popcorn',
    ChokladNutKrokant = 'Choklad & Nötkrokant'
}

export enum IceCreamMenu {
    Marangsviss = 'Klassisk marängsviss',
    Bananhalve = 'Bananhalve',
    GotlandskSommar = 'Gotländsk sommar',
    GuteBrickan = 'Gute brickan'
}

export enum Topping {
    //Sprikles
    RaspberrySprinkles = 'Hallon strössel',
    ChocolateSprinkles = 'Choklad strössel',
    SaltedCaramelCookies = 'Salta knäckkakor',
    SaltLicoriceFlakes = 'Saltlakrits-flakes',
    NutKrokant = 'Nötkrokant',
    PeppermintCandyCane = 'Polkagris',
    FruitSprinkles = 'Fruktströssel',
    PopcornCrunch = 'Popcorn crunch',
    //Sauce
    Salmberry = 'Salmbärssylt',
    ChocolateSauce = 'Chokladsås',
    CaramelSauce = 'Kolasås',
    Lemoncurd = 'Lemoncurd',
    RaspberrySauce = 'Hallonsås',
    SaltLakrits = 'Saltlakrits',
    Nougat = 'Nougat',
    ChocolateDip = 'Chokladdopp',
    NoSprinkles = 'Ingen topping'
}

export enum Container {
    Waffle = 'Våffla',
    Cup = 'Bägare',
    Emalj = 'Emaljbägare'
}
